// extracted by mini-css-extract-plugin
export default {"seriesButtonContainer":"ProfileSeries_seriesButtonContainer__58-rW"};